import prodConfig from './configureStore.prod';
import devConfig from './configureStore.dev';

let config;
if (process.env.NODE_ENV === 'production') {
    config = prodConfig;
} else {
    config = devConfig;
}

export default config;



// WEBPACK FOOTER //
// ./src/client/store/configureStore.js